import { Injectable } from '@angular/core';

import { TEMPO_LIMITE_DURACAO_AUDIO_MS } from '../util/duracao-audio.constantes';

@Injectable({ providedIn: 'root' })
export class DuracaoAudioService {
  private readonly cache = new Map<string, Promise<number | null>>();

  buscar(url: string): Promise<number | null> {
    let duracao = this.cache.get(url);
    if (!duracao) {
      duracao = this.carregar(url);
      this.cache.set(url, duracao);
    }
    return duracao;
  }

  private carregar(url: string): Promise<number | null> {
    return new Promise(resolve => {
      const audio = new Audio();
      let corrigindo = false;
      const concluir = (valor: number | null) => {
        clearTimeout(limite);
        audio.onloadedmetadata = null;
        audio.ondurationchange = null;
        audio.onerror = null;
        audio.removeAttribute('src');
        audio.load();
        resolve(valor);
      };
      const limite = setTimeout(() => concluir(null), TEMPO_LIMITE_DURACAO_AUDIO_MS);
      audio.preload = 'metadata';
      audio.onloadedmetadata = () => {
        if (Number.isFinite(audio.duration)) {
          concluir(audio.duration);
          return;
        }
        corrigindo = true;
        audio.currentTime = 1e101;
      };
      audio.ondurationchange = () => {
        if (corrigindo && Number.isFinite(audio.duration)) concluir(audio.duration);
      };
      audio.onerror = () => concluir(null);
      audio.src = url;
    });
  }
}
